import React from 'react';
import { Redirect, useLocalSearchParams } from 'expo-router';
import { legacyThisWeekTarget } from '../../src/navigation/legacyThisWeek';

/**
 * Retired screen (#768). Links already sent by email still point here, so the
 * route forwards them: see `legacyThisWeekTarget`.
 */
export default function ThisWeekRedirect() {
  const query = useLocalSearchParams();
  return <Redirect href={legacyThisWeekTarget(query)} />;
}
